import React, { useContext, useState, useMemo, useEffect } from 'react';
import Box from "@mui/material/Box";
import ButtonPrimary from "../../../common/components/Buttons/ButtonPrimary";
import { useQuery, useQueryClient } from 'react-query';
import { listTemplateParticipants } from '../../../../services/template/Participants';
import { CsrfContext } from '../../../../providers/CsrfProvider';
import { ThemeContext } from 'styled-components';
import RulesList from "../../components/RulesList";
import ParticipantsList from "../../components/ParticipantsList";

const ParticipantsStep = ({
    templateId,
    participants: initialParticipants,
    onAddParticipant,
    onRemoveParticipant,
    onContinue,
    groupId,
    disabled = false,
    isLoading = false,
    isCompleted = false
}) => {
    const theme = useContext(ThemeContext);
    const { csrfToken } = useContext(CsrfContext);
    const queryClient = useQueryClient();

    // Fetch participants if templateId exists
    const queryKey = useMemo(() => {
        if (!templateId) return ['participants', 'none']; // Use placeholder to keep queryKey valid
        const id = String(templateId);
        if (id === 'undefined' || id === 'null' || !id) return ['participants', 'none'];
        return ['participants', id];
    }, [templateId]);

    const { data: participants, isLoading: isLoadingParticipants } = useQuery(
        queryKey,
        listTemplateParticipants(csrfToken),
        {
            enabled: !!templateId && !!csrfToken && templateId !== 'none',
            refetchOnMount: false,
            refetchOnWindowFocus: false,
        }
    );

    // Reset queries when bill changes
    useEffect(() => {
        if (groupId && templateId && csrfToken && templateId !== 'none') {
            queryClient.invalidateQueries(['groupParticipantsExcludingBill', groupId, templateId]);
        }
    }, [templateId, groupId, csrfToken, queryClient]);

    // Ensure participantsList is always an array
    const participantsList = Array.isArray(participants)
        ? participants
        : Array.isArray(initialParticipants)
            ? initialParticipants
            : [];

    if (isCompleted) {
        return (
            <Box>
            {/*     <WithActions forceSpacing showSuccessButton={isCompleted}>*/}
            {/*         <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>*/}
            {/*             <Typography variant="h6" component="div" sx={{ mb: 2, textAlign: 'center' }}>*/}
            {/*                 Added*/}
            {/*             </Typography>*/}
            {/*         </Box>*/}
            {/*     </WithActions>*/}
            </Box>
        )
    }


    return (
        <Box
            sx={{
                opacity: disabled ? 0.6 : 1,
                borderRadius: '8px',
                margin: 0,
                transition: 'all 0.3s ease',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                paddingBottom: 0,
            }}
        >
            {/* Scrollable middle - fills remaining height so footer stays at bottom; only this area scrolls when content overflows */}
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                {/* Inner content with minHeight 100% so when content is shorter than container we can't scroll into blank space below rules */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        minHeight: '100%',
                        flexShrink: 0,
                    }}
                >
                    <Box sx={{ flexShrink: 0, width: '100%' }}>
                        <ParticipantsList
                        templateId={templateId}
                        groupId={groupId}
                        participants={participantsList}
                        onAddParticipant={onAddParticipant}
                        onRemoveParticipant={onRemoveParticipant}
                        disabled={disabled}
                        isLoading={isLoading}
                    />
                </Box>

                    {participantsList && Array.isArray(participantsList) && participantsList.length > 0 && (
                        <Box sx={{ flexShrink: 0, width: '100%' }}>
                            <RulesList 
                                templateId={templateId}
                                disabled={disabled}
                            />
                        </Box>
                    )}
                </Box>
            </Box>

            {/* Footer - flexShrink 0 keeps it at bottom of step when middle fills remaining space */}
            <Box
                sx={{
                    flexShrink: 0,
                    width: '100%',
                    backgroundColor: theme.colors.backgroundPrimary,
                    paddingTop: 2,
                    paddingBottom: 0,
                    borderTop: `1px solid ${(theme.colors && theme.colors.border) || 'rgba(0,0,0,0.12)'}`,
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
                    <ButtonPrimary
                        onClick={onContinue}
                        disabled={disabled || isLoading}
                        fullWidth
                    >
                        {participantsList.length > 0 ? 'Continue' : 'Later'}
                    </ButtonPrimary>
                </Box>
            </Box>
        </Box>
    );
};

export default ParticipantsStep;
